export default __webpack_public_path__ + "static/media/earrings_1.59198da2.webp";